import { render, staticRenderFns } from "./followupDetails.vue?vue&type=template&id=d3969844&scoped=true"
import script from "./followupDetails.vue?vue&type=script&lang=js"
export * from "./followupDetails.vue?vue&type=script&lang=js"
import style0 from "./followupDetails.vue?vue&type=style&index=0&id=d3969844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3969844",
  null
  
)

export default component.exports